import { render } from "./ImageViewerModal.vue?vue&type=template&id=2a20d8af&scoped=true"
import script from "./ImageViewerModal.vue?vue&type=script&lang=js"
export * from "./ImageViewerModal.vue?vue&type=script&lang=js"

import "./ImageViewerModal.vue?vue&type=style&index=0&id=2a20d8af&scoped=true&lang=css"

import exportComponent from "/var/www/html/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a20d8af"]])

export default __exports__